// extracted by mini-css-extract-plugin
module.exports = {"root":"IronBody_root__33N_7"};